import {
  OiGroupProcessDialogComponent,
  OiGroupDialogData,
} from './../../../shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { BaseService } from './../../../core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';

@Component({
  selector: 'app-pos-tfg-rewards-details-dialog',
  templateUrl: './pos-tfg-rewards-details-dialog.component.html',
  styleUrls: ['./pos-tfg-rewards-details-dialog.component.scss'],
})
export class PosTfgRewardsDetailsDialogComponent implements OnInit {
  form: FormGroup;
  tfgRewardsDetails: any = null;
  stores = [];
  identifierTypes = [];
  rewardsError: string = null;
  alreadyLinked: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PosTfgRewardsDetailsDialogComponent>,
    private fb: FormBuilder,
    private baseService: BaseService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.form = fb.group({
      storeId: [null, Validators.compose([Validators.required])],
      identifierType: [null, Validators.compose([Validators.required])],
      identifierValue: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(19),
          Validators.maxLength(19),
          Validators.pattern('[0-9]+'),
        ]),
      ],
    });
  }

  ngOnInit() {
    this.baseService
      .executeCommand<any>('portal_tfg_rewards_config', {
        salesOrderHeaderId: this.data.salesOrderHeaderId,
        salesOrderNumber: this.data.salesOrderNumber,
      })
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.stores = response.data.stores || [];
          this.identifierTypes = response.data.identifierTypes || [];
          this.tfgRewardsDetails = response.data.tfgRewardsDetails;
          if (this.tfgRewardsDetails) {
            this.alreadyLinked = true;
          }
        } else {
          this.stores = [];
          this.identifierTypes = [];
        }

        if (this.stores.length > 0) {
          this.form.controls['storeId'].setValue(this.stores[0].storeId);
        }
      });
  }

  validate() {
    this.tfgRewardsDetails = null;

    const dialogData: OiGroupDialogData = {
      title: 'Validating TFG Rewards',
      function: 'portal_oi_group_rewards_validate_profile',
      postBody: this.form.getRawValue(),
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px',
    });

    ref.afterClosed().subscribe((oiResult) => {
      if (
        oiResult.responseCode === 0 &&
        oiResult.data &&
        oiResult.data.groupProcessedSuccessfully === true
      ) {
        this.baseService
          .executeCommand<any>(
            'portal_tfg_rewards_get_customer_profile_by_oi_group_id',
            oiResult.data
          )
          .subscribe((detailResponse) => {
            if (detailResponse.responseCode === 0) {
              this.form.disable();
              if (detailResponse.data.IsSuccess === true) {
                this.tfgRewardsDetails = detailResponse.data;
              } else {
                this.rewardsError =
                  detailResponse.data.ErrorDescription ||
                  'Failed to load the reward profile, please try again later.';
              }
            }
          });
      }
    });
  }

  reset() {
    this.tfgRewardsDetails = null;
    this.rewardsError = null;
    this.form.controls['identifierValue'].reset();
    this.form.enable();
  }

  checkForTfgCardScan(event, value: string) {
    // CREDIT CARD
    // ;6277430011990943792=00000000000000372?

    // REWARDS
    // ;99060000124675835=00000000000000000?
    // ;99060000154210248=00000000000000000?
    if (value) {
      let regex = new RegExp(`^;[0-9]{17}=[0-9]{17}\\?$`);
      if (this.form.value.identifierType === 'TFG-CREDIT-CARD') {
        regex = new RegExp(`^;[0-9]{19}=[0-9]{17}\\?$`);
      }
      if (regex.test(value)) {
        const cardPieces = value.split('=');
        const cardNumber = cardPieces[0].replace(';', '');
        this.form.controls['identifierValue'].setValue(cardNumber);
        this.validate();
      } else {
        this.form.controls['identifierValue'].setValue(null);
        this.notificationService.error(`Wrong card scanned, please check if you selected to correct type (TFG Loyalty Card or TFG Credit Card)`);
      }

    }
  }

  identifierTypeChanged(event: any) {
    this.form.controls['identifierValue'].clearValidators();
    this.form.controls['identifierValue'].setValue(null);
    switch (this.form.value.identifierType) {
      case 'CELL-PHONE':
        this.form.controls['identifierValue'].setValidators(
          Validators.compose([
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern('[0-9]+'),
          ])
        );
        break;
      case 'PASSPORT':
        this.form.controls['identifierValue'].setValidators(
          Validators.compose([
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(16),
          ])
        );
        break;
      case 'RSA-ID':
        this.form.controls['identifierValue'].setValidators(
          Validators.compose([
            Validators.required,
            Validators.minLength(13),
            Validators.maxLength(13),
          ])
        );
        break;
      case 'TFG-CREDIT-CARD':
        this.form.controls['identifierValue'].setValidators(
          Validators.compose([
            Validators.required,
            Validators.minLength(19),
            Validators.maxLength(19),
            Validators.pattern('[0-9]+'),
          ])
        );
        break;
      case 'TFG-LOYALTY-CARD':
        this.form.controls['identifierValue'].setValidators(
          Validators.compose([
            Validators.required,
            Validators.minLength(17),
            Validators.maxLength(17),
            Validators.pattern('[0-9]+'),
          ])
        );
        break;
    }

    this.form.controls['identifierValue'].updateValueAndValidity();
    this.form.updateValueAndValidity();
  }

  linkRewards() {
    this.baseService
      .executeCommand<any>('portal_sales_order_header_link_tfg_rewards_account', {
        salesOrderHeaderId: this.data.salesOrderHeaderId,
        rewardsRequestId: this.tfgRewardsDetails
          ? this.tfgRewardsDetails.requestId
          : null,
      })
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        }
      });
  }
}
